import Vue from 'vue'
import VueI18n from 'vue-i18n'
import langConfig from './config'
import EN from 'element-ui/lib/locale/lang/en'
import ZH from 'element-ui/lib/locale/lang/zh-CN'
import ZH_HK from 'element-ui/lib/locale/lang/zh-TW'
import DE from 'element-ui/lib/locale/lang/de'
import IT from 'element-ui/lib/locale/lang/it'
import UA from 'element-ui/lib/locale/lang/ua'
import FR from 'element-ui/lib/locale/lang/fr'
import TH from 'element-ui/lib/locale/lang/th'

import enLocal from './en-US'
import zhLocal from './zh-CN'
import zhHKLoacl from './zh-HK'
import deLocal from './de-DE'
import itLocal from './it-IT'
import ukLocal from './uk-UA'
import frLocal from './fr-FR'
import thLocal from './th-TH'

Vue.use(VueI18n)

const i18nMessages = {
  'zh-CN': {
    ...zhLocal,
    ...ZH
  },
  'en-US': {
    ...enLocal,
    ...EN
  },
  'zh-HK': {
    ...zhHKLoacl,
    ...ZH_HK
  },
  'de-DE': {
    ...deLocal,
    ...DE
  },
  'it-IT': {
    ...itLocal,
    ...IT
  },
  'uk-UA': {
    ...ukLocal,
    ...UA
  },
  'fr-FR': {
    ...frLocal,
    ...FR
  },
  'th-TH': {
   ...thLocal,
   ...TH
  }
}

const { languageSelectList } = langConfig
const localeObj = {}

// 动态构建messages (自动处理所有在languageSelectList中的语言)
const messages = languageSelectList.reduce((acc, langConfig) => {
  
  const langCode = langConfig.value
  const baseLang = langCode.split('-')[0]
  
  localeObj[langCode] = langCode
  localeObj[baseLang] = langCode
  
  if(!i18nMessages[langCode]) {
    
    const elementLang = require(`element-ui/lib/locale/lang/${baseLang}`).default || {}
    const customLang = require(`./${langCode}`).default || {}
    
    // 判空处理 - 如果语言包不存在，使用空对象避免崩溃
    acc[langCode] = {
      ...customLang,
      ...elementLang
    }
  } else {
    acc[langCode] = i18nMessages[langCode]
  }
  
  return acc
}, {})
// console.log('messages', messages)
// const localeObj = {
//   'zh-CN': 'zh-CN',
//   'zh': 'zh-CN',
//   'en-US': 'en-US',
//   'en': 'en-US',
//   'de-DE': 'de-DE',
//   'de': 'de-DE',
//   'it-IT': 'it-IT',
//   'it': 'it-IT',
//   'uk-UA': 'uk-UA',
//   'uk': 'uk-UA',
//   'fr-FR': 'fr-FR',
//   'fr': 'fr-FR',
//   'th-TH': 'th-TH',
//   'th': 'th-TH',
// }

const currentLocale = navigator.language // 获取浏览器语言
const accLan = localStorage.getItem('Accept-Language') // 获取用户自定义语言
// 如果默认语言不存在，则使用浏览器语言
if (!accLan) {
  if (currentLocale && localeObj[currentLocale]) {
    localStorage.setItem('Accept-Language', localeObj[currentLocale]);
  } else {
    localStorage.setItem('Accept-Language', 'en-US');
  }
}

const i18n = new VueI18n({
  locale: localStorage.getItem('Accept-Language') || 'en-US', // 设置语种
  messages, // 设置全局当地语言包,
  fallbackLocale: 'en', //如果没有找到要显示的语言，则默认显示 ‘en’
  silentTranslationWarn: true // 关闭警告信息
})

export default i18n
